import { createContext, useContext } from "react";
import { toast } from "react-toastify";
import { timeToast } from "../Constant";
import useAxios from "../Utils/useAxios";
import { 
  getItemSubmitSuccessMsg, 
  getItemDeleteSuccessMsg,
  getItemCreateSuccessMsg
} from "../Constant/Message";
import DATA_TYPE from "../Constant/DataType";
import { openPdfInNewTab } from "../Utils/otherFunctions";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const AbsensiContext = createContext();

export const useAbsensi = () => useContext(AbsensiContext);

export const AbsensiProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getTipeAbsensi: () => 
      axiosInstance.get("sipeg/tipe-absensi/")
        .catch(err => handleError(err, "GET Tipe Absensi")),
    
    getLokasi: () => 
      axiosInstance.get("sipeg/absensi/lokasi/")
        .catch(err => handleError(err, "GET Lokasi")),
    
    getAbsensiByDate: (date) => 
      axiosInstance.get(`sipeg/absensi/date/${date}`)
        .catch(err => handleError(err, "GET Absensi")),
    
    getAbsensiByMonth: (month) => 
      axiosInstance.get(`sipeg/absensi/month/${month}`)
        .catch(err => handleError(err, "GET Absensi")),
    
    getAbsensiByStafAndDate: (userId, date) => 
      axiosInstance.get(`sipeg/absensi/${userId}/${date}`)
        .catch(err => handleError(err, "GET Absensi")),
    
    getDetailAbsensiByDate: (date) => 
      axiosInstance.get(`sipeg/absensi/detail/date/${date}`)
        .catch(err => handleError(err, "GET Detail Absensi")),
    
    getDetailAbsensiByMonth: (date) => 
      axiosInstance.get(`sipeg/absensi/detail/month/${date}`)
        .catch(err => handleError(err, "GET Detail Absensi")),
    
    getDetailAbsensiByStafAndDate: (userId, date) => 
      axiosInstance.get(`sipeg/absensi/detail/${userId}/${date}`)
        .catch(err => handleError(err, "GET Detail Absensi")),
    
    getRekapBulananAbsensi: () => 
      axiosInstance.get("sipeg/absensi/rekap-absensi/")
        .catch(err => handleError(err, "GET Rekap Bulanan Absensi")),
    
    getRekapBulananAbsensiByMonth: (yearFilter) => 
      axiosInstance.get(`sipeg/absensi/rekap-absensi/bulanan/${yearFilter}`)
        .catch(err => handleError(err, "GET Rekap Bulanan Absensi")),
    
    getRekapHarianAbsensi: () => 
      axiosInstance.get("sipeg/absensi/rekap-absensi/harian/")
        .catch(err => handleError(err, "GET Rekap Harian Absensi")),
    
    getRekapHarianAbsensiByMonth: (monthFilter) => 
      axiosInstance.get(`sipeg/absensi/rekap-absensi/harian/${monthFilter}`)
        .catch(err => handleError(err, "GET Rekap Harian Absensi")),
    
    getRekapHarianByMonthAbsensi: (month) => 
      axiosInstance.get(`sipeg/absensi/rekap-absensi/harian/month/${month}`)
        .catch(err => handleError(err, "GET Rekap Harian Absensi")),
    
    getEventByPeriod: (periode) => 
      axiosInstance.get(`kalender/${periode}`)
        .catch(err => handleError(err, "GET Event")),
    
    getAbsenExport: (year, month = null, filter) => 
      axiosInstance.post(`sipeg/absensi/rekap-absensi/export/${year}${month ? `/${month}` : ""}`, filter, {
        responseType: "blob",
      })
      .then(res => {
        const filename = res.headers["content-disposition"]
          .split("filename=")[1]
          .replace(/['"]/g, "");
        const file = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileURL = URL.createObjectURL(file);
        const dom = document.createElement("a");
        dom.setAttribute("style", "display:none");
        dom.setAttribute("href", fileURL);
        dom.setAttribute("target", "_blank");
        dom.setAttribute("download", filename);
        document.body.appendChild(dom);
        dom.click();
        URL.revokeObjectURL(fileURL);
        document.body.removeChild(dom);
        return handleSuccess(res, getItemCreateSuccessMsg("Absen"));
      })
      .catch(err => handleError(err, "GET Absen Export")),
    
    getAbsenStafExport: (stafId, date) => 
      axiosInstance.get(`sipeg/absensi/detail/${stafId}/${date}/cetak`, {
        responseType: "blob",
      })
      .then(res => {
        openPdfInNewTab(res);
        return handleSuccess(res, getItemCreateSuccessMsg("Tanda Terima"));
      })
      .catch(err => handleError(err, "GET Absen Export")),
    
    createAbsensi: (formData) => 
      axiosInstance.post("sipeg/absensi/", formData)
        .then(res => handleSuccess(res, getItemSubmitSuccessMsg("Absensi")))
        .catch(err => handleError(err, "POST Absensi")),
    
    createDetailAbsensi: (formData) => 
      axiosInstance.post("sipeg/absensi/detail/", formData)
        .then(res => handleSuccess(res, getItemSubmitSuccessMsg("Detail Absensi")))
        .catch(err => handleError(err, "POST Detail Absensi")),
    
    updateAbsensi: (id, formData) => 
      axiosInstance.put(`sipeg/absensi/${id}`, formData)
        .then(res => handleSuccess(res, getItemSubmitSuccessMsg("Absensi")))
        .catch(err => handleError(err, "PUT Absensi")),
    
    deleteAbsensi: async (id) => {
      try {
        await axiosInstance.delete(`sipeg/absensi/${id}`);
        return handleSuccess({}, getItemDeleteSuccessMsg(DATA_TYPE.Absensi));
      } catch (err) {
        return handleError(err, "DELETE (Absensi)");
      }
    }
  };

  return (
    <AbsensiContext.Provider value={api}>
      {children}
    </AbsensiContext.Provider>
  );
};

export default AbsensiContext;